var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{staticClass:"px-2 mb-3"},[_c('DineInBasicDetailsForm',{ref:"basicDetails",on:{"setUntouchedForm":_vm.setUntouchedForm}}),_c('DineInQRCodeForm',{ref:"qrCode",on:{"setUntouchedForm":_vm.setUntouchedForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }